"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmitterBaseClass = void 0;
const mitt_1 = __importDefault(require("mitt"));
class EmitterBaseClass {
    constructor() {
        this.allHandlers = new Map();
        this.emitter = (0, mitt_1.default)();
    }
    emit(event, data) {
        if (!this.emitter) {
            console.warn("[EmitterBaseClass] trying to emit on destroyed emitter");
            return;
        }
        this.emitter.emit(event, data);
    }
    once(event, handler) {
        var _a;
        const fn = (data) => {
            var _a;
            (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.off(event, fn);
            handler(data);
        };
        (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.on(event, fn);
    }
    on(event, handler) {
        var _a;
        (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.on(event, handler);
    }
    onAll(handler) {
        var _a;
        const allHandler = (event, data) => {
            handler({
                event,
                data,
            });
        };
        if (this.allHandlers.has(handler)) {
            this.offAll(handler);
        }
        this.allHandlers.set(handler, allHandler);
        (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.on("*", allHandler);
    }
    // public onAllTest();
    off(event, handler) {
        var _a;
        (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.off(event, handler);
    }
    offAll(handler) {
        var _a;
        const allHandler = this.allHandlers.get(handler);
        if (allHandler) {
            (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.off("*", allHandler);
        }
        else {
            console.warn("[EmitterBaseClass] trying to remove non-existing all handler");
        }
    }
    addEventListener(event, handler) {
        this === null || this === void 0 ? void 0 : this.on(event, handler);
    }
    removeEventListener(event, handler) {
        this === null || this === void 0 ? void 0 : this.off(event, handler);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    destroy(_) {
        var _a;
        (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.off("*");
        this.emitter = undefined;
    }
}
exports.EmitterBaseClass = EmitterBaseClass;
//# sourceMappingURL=EmitterBaseClass.js.map